/**
 *
 * Styles for FeedbackMessage
 *
 */

import styled, { css } from "styled-components";
import { DhlText } from "@dhl-official/react-library";

const variations = {
  error: css`
    color: var(--dui-color-red-500) !important;
  `,
  warning: css`
    color: var(--dui-color-gray-700) !important;
    background-color: var(--dui-color-gray-100) !important;
    padding: var(--dui-size-space-4x) var(--dui-size-space-5x)
      var(--gaq-size-space-5px) !important;
  `,
  hint: css`
    background-color: var(--dui-color-white-500) !important;
    border: var(--dui-size-width-border-xs) solid var(--dui-color-gray-300) !important;
    padding: var(--gaq-size-space-15px) var(--dui-size-space-7x) !important;
    color: var(--dui-color-black-500) !important;
  `,
};

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    color: var(--dui-color-red-500) !important;
    margin-top: var(--dui-size-space-5x) !important;
    text-decoration: ${(props) =>
      props.underline ? "underline" : "none"} !important;
    ${(props) => variations[props.variation]};
    ${(props) => (props.centered ? "text-align: center; !important" : "")};
  }
`;
